import { useContext } from "react";
import { ThemeContext, ThemeContextProps } from "@shared/EDS/contexts/ThemeContext";

export function useTheme(): ThemeContextProps {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useTheme must be used within a ThemeContextProvider");
  }
  return context;
}
